import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Cookie, Database, Bell, Settings } from 'lucide-react';
import Footer from '../components/Footer';

export default function Cookies() {
  return (
    <>
      <Helmet>
        <title>Política de Cookies - Concurso de Árboles de Navidad</title>
        <meta 
          name="description" 
          content="Información sobre el uso de cookies en el concurso de árboles de Navidad." 
        />
      </Helmet>

      <div className="min-h-screen pt-16">
        <div className="bg-primary text-white py-20">
          <div className="container mx-auto px-4 text-center">
            <Cookie className="h-16 w-16 mx-auto mb-6 text-secondary" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Política de Cookies</h1>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto">
              Información sobre el uso de cookies en nuestra web
            </p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-12">
          <div className="max-w-3xl mx-auto space-y-12">
            <section>
              <div className="flex items-center mb-4">
                <Cookie className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">¿Qué son las cookies?</h2>
              </div>
              <div className="prose prose-lg">
                <p>
                  Las cookies son pequeños archivos de texto que los sitios web almacenan en tu 
                  dispositivo cuando los visitas. Sirven para recordar información sobre tu visita 
                  y mejorar tu experiencia de usuario.
                </p>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Database className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Tipos de Cookies que Utilizamos</h2>
              </div>
              <div className="prose prose-lg">
                <h3 className="text-xl font-semibold mt-6 mb-4">Cookies Técnicas (Necesarias)</h3>
                <ul>
                  <li>Mantener tu sesión iniciada</li>
                  <li>Recordar tus preferencias básicas</li>
                  <li>Garantizar el funcionamiento técnico del sitio</li>
                </ul>

                <h3 className="text-xl font-semibold mt-6 mb-4">Cookies de Análisis</h3>
                <ul>
                  <li>Entender cómo utilizas el sitio</li>
                  <li>Mejorar nuestros servicios</li>
                  <li>Medir la efectividad de nuestras funciones</li>
                </ul>

                <h3 className="text-xl font-semibold mt-6 mb-4">Cookies de Preferencias</h3>
                <ul>
                  <li>Recordar tus votos y participaciones</li>
                  <li>Personalizar tu experiencia</li>
                  <li>Mantener tus ajustes de visualización</li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Settings className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Control de Cookies</h2>
              </div>
              <div className="prose prose-lg">
                <p>
                  Puedes controlar y/o eliminar las cookies como desees. Puedes eliminar todas las 
                  cookies que ya están en tu dispositivo y puedes configurar la mayoría de los 
                  navegadores para que no las acepten.
                </p>
                <p>
                  Para gestionar las cookies en los principales navegadores:
                </p>
                <ul>
                  <li>Chrome: Configuración {'>'} Privacidad y seguridad {'>'} Cookies</li>
                  <li>Firefox: Opciones {'>'} Privacidad {'>'} Historial</li>
                  <li>Safari: Preferencias {'>'} Privacidad</li>
                  <li>Edge: Configuración {'>'} Cookies y permisos del sitio</li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Bell className="h-6 w-6 text-primary mr-2" />
                <h2 className="text-2xl font-bold text-gray-900">Actualizaciones</h2>
              </div>
              <div className="prose prose-lg">
                <p>
                  Podemos actualizar esta política de cookies ocasionalmente. Te recomendamos 
                  que la revises periódicamente para estar informado de cualquier cambio.
                </p>
                <p>
                  Última actualización: Diciembre 2023
                </p>
              </div>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}